var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 18.0001C21.9781 18.0001 25.2001 14.7781 25.2001 10.8001C25.2001 6.8221 21.9781 3.6001 18.0001 3.6001C14.0221 3.6001 10.8001 6.8221 10.8001 10.8001C10.8001 14.7781 14.0221 18.0001 18.0001 18.0001ZM18.0001 21.6001C13.1941 21.6001 3.6001 24.0121 3.6001 28.8001V32.4001H32.4001V28.8001C32.4001 24.0121 22.8061 21.6001 18.0001 21.6001Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.96550cfa146e9bc40908a61ff2f80d69.svg";
export { ForwardRef as ReactComponent };